import React from 'react';
import {Transport} from 'types/transport/Abstract/AbstractTransport';

export const transportDataGetterContext = React.createContext<{
   getTransportData: () => Transport;
   partnerId: string;
   path?: string;
   anonymous?: boolean;
   partner?: boolean;
}>({
   getTransportData: () => {
      console.debug('getTransportData not implemented');
      return {} as Transport;
   },
   partnerId: 'Non implemented',
   anonymous: false,
   partner: false,
});

export const TransportDataGetterContextProvider = transportDataGetterContext.Provider;
